<template>
    <div class="Error404">
        <Navbar />

            <section class="p-5">
                <div class="container">
                    <h5 class="mb-0">
                        Oops, we couldn't find that page. <font-awesome-icon :icon="['fad', 'frown']" />
                    </h5>
                </div>
            </section>

        <Footer />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
    name: 'Error404',
    data: () => ({
    }),
    components: {
        Navbar,
        Footer
    },
    mounted () {
        console.log(this.$route);
    }
}
</script>
